import AboutUsHeader from "../Components/About-us/AboutUsHeader";

function AboutUs() {
  return (
    <div>
      <AboutUsHeader></AboutUsHeader>
    </div>
  );
}

export default AboutUs;
